export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/elearning.6475107.svg";